import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
}

/**
 * Verify (claim) a marketplace profile by username.
 * Requires auth. Backend checks logged-in user's username matches the profile username.
 */
export const verifyClaim = async (username) => {
  const res = await axios.post(
    `${API_BASE_URL}/auth/marketplace/claim/verify`,
    { username },
    { headers: getAuthHeaders(), withCredentials: true }
  );
  return res.data;
};
